import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} className="flex items-center gap-1">
              {idx > 0 && (
                <span className="text-foreground-400 mx-1">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`whitespace-nowrap ${isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}`}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export function getCategoryBreadcrumb(slug: string) {
  const cat = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '分类' },
  ];
}

export function getArticleBreadcrumb(videoTitle: string, categorySlug: string) {
  const cat = categories.find((c) => c.slug === categorySlug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '分类', href: `/category/${categorySlug}` },
    { label: videoTitle },
  ];
}